import { dimensions, fontFamily, palette } from "./foundation";
import { createGlobalStyle } from "styled-components";

// 主要ブラウザのデフォルトの文字サイズは16px
// 62.5%にすると10px
// 10pxが1remなので、1.4remにすると14px
const GlobalStyles = createGlobalStyle`
  html {
    font-family: ${fontFamily.gothic};
    font-size: 62.5%;
    min-width: 320px;
  }
  body {
    background-color: ${palette.gray.light};
    color: ${palette.ink.normal};
    font-size: 1.5rem;
    line-height: 2;
    margin: 0;
    overscroll-behavior: none;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.6rem;
      line-height: 2;
    }
  }
  a {
    color: ${palette.ink.normal};
    text-decoration: none;
    transition: color .2s ease, 
                background-color .2s ease,
                border-color .2s ease,
                text-decoration .2s ease,
                opacity .2s ease;
    &:hover {
      color: ${palette.red.dark};
      text-decoration: underline;
    }
  }
  button {
    transition: color .2s ease, 
                background-color .2s ease,
                border-color .2s ease,
                text-decoration .2s ease,
                opacity .2s ease;
  }
  address {
    font-style: normal
  }
  h1, h2, h3, h4 {
    font-family: ${fontFamily.serif};
    font-weight: normal;
    margin: 0;
  }
  img {
    display: block;
    max-width: 100%;
    height: auto;
    transition: opacity .2s ease;
  }
  ul {
    margin: 0
  }
  button {
    color: ${palette.ink.normal};
    font-family: ${fontFamily.gothic};
    font-size: 1.5rem;
    line-height: 2;
  }
  dl {
    margin: 0;
  }
  dd {
    margin: 0;
  }
  p {
    margin: 0;
  }
  main {
    display: block
  }
`;

export default GlobalStyles;
